import type { PricesEntry } from '@cocoonspace/sdk-js/types/pricesEntry'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Trans } from 'next-i18next'
import { memo, useMemo } from 'react'

interface DayProps {
	date: Date
	calendarPrices: PricesEntry[]
}

const CalendarDayWithPrice = ({ date, calendarPrices }: DayProps) => {
	const price = useMemo(() => {
		const res = calendarPrices?.find(
			({ day }) => day === dateTimeUtils(date).customFormat('dateTech'),
		)

		return res?.price_hour_discounted ?? res?.price_hour
	}, [calendarPrices, date])

	const priceTrad = !!Number(price?.toString().slice(-2)) // if decimals -> full variant
		? 'common:currency.full'
		: 'common:currency.short'

	return (
		<div className='flex flex-col gap-y-1 leading-none'>
			{date.getDate()}

			{price !== undefined && (
				<Trans
					parent='div'
					i18nKey={priceTrad}
					values={{ val: price / 100 }}
					className='text-xxs leading-none'
				/>
			)}
		</div>
	)
}

export default memo(CalendarDayWithPrice)
